export default {
      id: "MMB_2x-usage",
      viewBox: "0 0 50 36",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#MMB_2x",
      toString: function () {
        return this.url;
      }
    }